/* eslint-disable no-console */
<template>
  <div class="relative">
    <span
      :class="['switch-selected-' + currentItem, sliderClass]"
      :style="{ transform: `translateX(${left}px)`, width: `${width}px` }"
    ></span>
    <div class="relative" :class="[innerContainerClass]" ref="items-container">
      <router-link
        v-for="(item, i) in options"
        :key="i"
        :ref="item.name"
        class="inline-block"
        :class="[
          'switch-item-' + i,
          { [itemActiveClass]: $t(item.name) === active },
          itemClass,
        ]"
        :to="item.to"
        :exact="item.exact"
      >
        <font-awesome-icon
          v-if="item.icon"
          :icon="['fas', item.icon]"
          class=""
        />
        <span v-else>{{ $t(item.name) }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number],
      default: "",
    },
    exact: {
      type: Boolean,
      default: false,
    },
    itemClass: {
      type: String,
      default:
        "text-gray-500 rounded-full hover:text-gray-600 transition font-medium py-2 px-4 bg-transparent focus:outline-none",
    },
    itemActiveClass: {
      type: String,
      default: "text-gray-600",
    },
    roundedStyle: {
      type: String,
      default: "rounded-full",
    },
    sliderClass: {
      type: String,
      default:
        "absolute inset-y-0 my-1 w-full bg-white shadow-md rounded-full ease-out transition-all duration-500 switch-selector",
    },
    innerContainerClass: {
      type: String,
      default: "",
    },
    active: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      width: 0,
      left: 0,
    };
  },
  computed: {
    currentItem() {
      return this.options.findIndex((e) => e.to.name === this.$route.name);
    },
    // formattedOptions() {
    //   return this.options.map((e) => ({
    //     ...e,
    //     ref: e.to.indexOf("?") > -1 ? e.to.slice(0, e.to.indexOf("?")) : e.to,
    //   }));
    // },
  },
  watch: {
    $route() {
      this.setPosition();
    },
  },
  mounted() {
    this.setPosition();

    // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.setPosition();
      });

      this.resizeObserver.observe(this.$refs["items-container"]);
    } else {
      // for IE
      window.addEventListener("resize", this.setPosition);
    }
  },
  // for Vue 3
  // beforeUnmount() {
  //   this.removeResizeObserver();
  // },
  // for Vue 2
  beforeDestroy() {
    this.removeResizeObserver();
  },
  methods: {
    removeResizeObserver() {
      if (window.ResizeObserver) {
        this.resizeObserver.unobserve(this.$refs["items-container"]);
      } else {
        // for IE
        window.removeEventListener("resize", this.setPosition);
      }
    },
    setPosition() {
      this.$nextTick(function () {
        // DOM is now updated
        let el;

        el = this.$refs[this.active]?.[0]?.$el;

        if (el) {
          this.width = el.getBoundingClientRect().width;
          this.left = el.offsetLeft;
        } else {
          this.width = 0;
          this.left = 0;
        }
      });
    },
    // setPosition() {
    //   this.$nextTick(function() {
    //     // DOM is now updated
    //     let el;

    //     // find the first one of the matched routes that we have in our options
    //     if (this.exact) {
    //       // strip the last / if present
    //       const path =
    //         this.$route.fullPath[this.$route.fullPath.length - 1] === "/" &&
    //         this.$route.fullPath !== "/"
    //           ? this.$route.fullPath.slice(0, -1)
    //           : this.$route.fullPath;

    //       el = this.$refs[path]?.[0]?.$el;
    //     }
    //     // special case - only for the home - "/"
    //     // else if (this.$route.path === "/") {
    //     //   el = this.$refs["/"]?.[0]?.$el;
    //     // }
    //     else {
    //       const matched = this.$route.matched.find((e) => {
    //         return this.options.some((op) => e.name === op.to.name);
    //       });
    //       // console.log({ matched });
    //       const path = matched?.name;

    //       el = this.$refs[path]?.[0]?.$el;
    //     }

    //     if (el) {
    //       this.width = el.getBoundingClientRect().width;
    //       this.left = el.offsetLeft;
    //     } else {
    //       this.width = 0;
    //       this.left = 0;
    //     }
    //   });
    // },
  },
};
</script>
